import { useTextField } from "@website/ui/text-field/text-field.hook";
import styles from "@website/ui/text-field/text-field.module.scss";
import { TextFieldPropertiesType } from "@website/ui/text-field/text-field.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const TextField: FC<TextFieldPropertiesType> = (properties) => {
  const {
    className,
    inputClassName,
    disabled,
    error,
    EndIcon,
    fullWidth,
    helperText,
    label,
    prefix,
    size,
    StartIcon,
    suffix,
    hasFocusStyle = true,
    multiLine = false,
    type,
    accept,
    noBorder,
    labelClassName
  } = properties;
  const {
    rootProperties,
    inputProperties,
    startIconProperties,
    endIconProperties
  } = useTextField(properties);

  return (
    <div
      className={`${styles["text-field"]} ${error ? styles["error"] : ""} ${
        disabled ? styles["disabled"] : ""
      } ${styles[size || "default"]} ${
        fullWidth ? styles["fullWidth"] : ""
      } ${noBorder
        ?.map((item) => `${styles[`no-border-${item}`]}`)
        .join(" ")} ${className ?? ""}`}
      {...rootProperties}
      data-error={error}
    >
      <div
        className={`${className} ${styles["box"]} ${
          hasFocusStyle ? styles["box__has-focus"] : ""
        }`}
      >
        {StartIcon ? (
          <div {...startIconProperties} className={styles["start-icon"]}>
            {StartIcon}
          </div>
        ) : null}
        {prefix ? <div className={styles["prefix"]}>{prefix}</div> : null}
        {multiLine ? (
          <textarea
            className={`${inputClassName} ${styles["input"]} ${
              label ? styles["has-label"] : ""
            } ${styles["no-resize"]} block h-full`}
            {...inputProperties}
          />
        ) : (
          <input
            accept={accept}
            type={type}
            {...inputProperties}
            className={`${inputClassName} ${styles["input"]} ${
              label ? styles["has-label"] : ""
            } ${styles["dense"]}`}
          />
        )}
        {suffix ? <div className={styles["suffix"]}>{suffix}</div> : null}
        {EndIcon ? (
          <div {...endIconProperties} className={styles["end-icon"]}>
            {EndIcon}
          </div>
        ) : null}
        {label ? (
          <label
            className={`${styles["label"]} ${labelClassName} ${
              prefix || StartIcon ? styles["active"] : ""
            }`}
          >
            {label}
          </label>
        ) : null}
      </div>
      {helperText ? (
        <div className={styles["helper-text"]}>{helperText}</div>
      ) : null}
    </div>
  );
};

const TextFieldMemoized = memo(TextField, deepCompare);
export { TextFieldMemoized as TextField };
